import React from 'react';
import './App.css';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Header from './compontnts/Header';
import styled from "styled-components";
import Sidebar from './compontnts/Sidebar';
import Chat from './compontnts/Chat';
import { useAuthState } from 'react-firebase-hooks/auth'
import { auth } from './firebase';
import Login from './compontnts/Login';
import Spinner from 'react-spinkit';

function App() {

  const [user, loading] = useAuthState(auth);

  if (loading) {

    return (

      <AppLoading>
        <AppLoadingContents>
          <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQGRtAVwVEG38xBNXT20DiAmuGWnK3YJ64w2TM4zkH-WoKb3B6Sno7h5bvJssQnK5U8Xs4&usqp=CAU"
            alt="" />

          <Spinner name="ball-spin-fade-loader"
            color="purple" fadeIn="none" />
        </AppLoadingContents>
      </AppLoading>

    )
  }

  return (
    <div className="App">

      <Router>
        {!user ? (
          <Login />
        ) : (
          <>
            <Header />

            <AppBody>
              <Sidebar />
              <Switch>

                <Route path="/" exact>
                  <Chat />
                </Route>

              </Switch>
            </AppBody>

          </>

        )}


      </Router>

    </div>
  );
}

export default App;

const AppBody = styled.div`
    display: felx;
    height: 100vh;
 
`;

const AppLoading = styled.div`

  display:grid;
  place-items:center;
  height:100vh;
  width:100%

`;

const AppLoadingContents = styled.div`
  text-align:center;
  padding-bottom:100px;
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;

  >img{
    height:100px;
    padding:20px;
    margin-bottom:40px;
  }
`;